<input
  #searchInput
  [disabled]="disabled"
  [class]="inputClass"
  [id]="inputId"
  [value]="displayValue"
  autocomplete="off"
  (keyup)="onKeyUp($event)"
  (keydown)="onKeyDown($event)"
  [matAutocomplete]="productAuto"
  [placeholder]="placeholder" />

<mat-autocomplete #productAuto="matAutocomplete"
  (optionSelected)="onOptionSelected($event)"
  [panelWidth]="670"
  [autoActiveFirstOption]="true"
  class="product-search-panel">
  <!-- 欄位標題 -->
  <mat-option *ngIf="productOptions.length > 0 && !isLoading" disabled class="header-option">
    <div class="product-row header">
      <span class="col-code">貨號</span>
      <span class="col-name">商品名稱</span>
      <span class="col-vendor">廠商自編碼</span>
      <span class="col-barcode-rx">條碼/醫令/健保碼</span>
    </div>
  </mat-option>
  <!-- 載入中 -->
  <mat-option *ngIf="isLoading" disabled class="loading-option">
    搜尋中...
  </mat-option>
  <!-- 無結果 -->
  <mat-option *ngIf="showNoResult && !isLoading" disabled class="no-result-option">
    查無符合的商品
  </mat-option>
  <!-- 搜尋結果 -->
  <mat-option *ngFor="let opt of productOptions" [value]="opt.value">
    <div class="product-row">
      <span class="col-code">
        <ng-container *ngIf="getHighlight(opt.extension?.ProductCode) as h">
          {{h.before}}<span class="highlight" *ngIf="h.match">{{h.match}}</span>{{h.after}}
        </ng-container>
      </span>
      <span class="col-name">
        <app-stocks-product-tags [product]="opt.extension"></app-stocks-product-tags>
        <ng-container *ngIf="getHighlight(opt.extension?.ProductName) as h">
          {{h.before}}<span class="highlight" *ngIf="h.match">{{h.match}}</span>{{h.after}}
        </ng-container>
      </span>
      <span class="col-vendor">
        <ng-container *ngIf="getHighlight(opt.extension?.VendorSelfCode) as h">
          {{h.before}}<span class="highlight" *ngIf="h.match">{{h.match}}</span>{{h.after}}
        </ng-container>
      </span>
      <span class="col-barcode-rx">
        <ng-container *ngIf="getHighlight(opt.extension?.BarcodeOrRxCode) as h">
          {{h.before}}<span class="highlight" *ngIf="h.match">{{h.match}}</span>{{h.after}}
        </ng-container>
      </span>
    </div>
  </mat-option>
</mat-autocomplete>
